import{useState as r,useCallback as e,useEffect as t}from"react";function o({correctMessage:o,errorMessage:n}){const[s,a]=r(null),c=e((()=>{a(n||(o||null))}),[n,o]);return t((()=>{c()}),[c]),s}export{o as default};
//# sourceMappingURL=useTextFieldMessage.js.map
